import { InstagramLogo } from '@/assets/svg';
import BaseSocialModal from './BaseSocialModal';

export default class Instagram extends BaseSocialModal {
  constructor(props) {
    super(props, 'Instagram');
    this.logo = InstagramLogo;
  }

  render() {
    return this.renderSocialModal();
  }
}
